import { Button, IconClose, Layout, Modal, Text, cnMixCard, cnMixSpace } from 'uikit';

import type React from 'react';
import { useState, useCallback, useEffect } from 'react';

import styles from './ConfirmationDialog.module.css';

interface IConfirmationDialog {
    isOpened: boolean;
    onSubmit: () => void;
    onClose: (value: boolean) => void;
    textHeader: string;
    textConfirmation: string | React.ReactNode;
    cancelButtonText: string;
    confirmButtonText: string;
    onClickOutside?: () => void;
    preventButtonsDefaults?: boolean;
    confirmationOnly?: boolean;
    styleError?: boolean;
}

const bodyStyle = { padding: '0 24px' };

export const ConfirmationDialog: React.FC<IConfirmationDialog> = ({
    isOpened,
    onSubmit,
    onClose,
    textConfirmation,
    textHeader,
    cancelButtonText,
    confirmButtonText,
    onClickOutside,
    preventButtonsDefaults,
    confirmationOnly,
    styleError,
}) => {
    const [isWaiting, setIsWaiting] = useState<boolean>(false);

    const handleClose = useCallback(
        (e) => {
            if (preventButtonsDefaults) {
                e.stopPropagation();
                e.preventDefault();
            }

            onClose(false);
        },
        [onClose, preventButtonsDefaults],
    );

    const handleOk = useCallback(
        (e) => {
            if (preventButtonsDefaults) {
                e.stopPropagation();
                e.preventDefault();
            }

            setIsWaiting(true);
            onSubmit();
            setIsWaiting(false);
            onClose(true);
        },
        [onClose, onSubmit, preventButtonsDefaults],
    );

    useEffect(
        () => () => {
            setIsWaiting(false);
        },
        [],
    );

    return (
        <Modal
            isOpen={isOpened}
            hasOverlay
            style={{ minHeight: '204px', width: '520px' }}
            onClickOutside={onClickOutside}
            className={styleError ? styles.error : ''}
        >
            <>
                <div className={styles.header}>
                    <Text transform="uppercase" view="secondary" lineHeight="l" size="s" weight="semibold">
                        {textHeader}
                    </Text>
                    <Button
                        onClick={handleClose}
                        label="Закрыть"
                        iconSize="s"
                        iconLeft={IconClose}
                        view="clear"
                        onlyIcon
                    />
                </div>
                <Layout
                    className={cnMixCard({
                        verticalSpace: 'l',
                    })}
                    flex={1}
                >
                    {typeof textConfirmation === 'string' && <Text style={bodyStyle}>{textConfirmation}</Text>}
                    {typeof textConfirmation !== 'string' && textConfirmation}
                </Layout>
                <Layout className={styles.footer} style={{ justifyContent: 'right' }}>
                    <Button
                        loading={isWaiting}
                        className={cnMixSpace({ mR: 'm' })}
                        label={confirmButtonText}
                        onClick={handleOk}
                    />
                    {!confirmationOnly && (
                        <Button loading={isWaiting} label={cancelButtonText} onClick={handleClose} view="ghost" />
                    )}
                </Layout>
            </>
        </Modal>
    );
};

ConfirmationDialog.displayName = 'ConfirmationDialog';
